export default "__VITE_ASSET__CrUsJk4N__"